import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { mainCq } from 'bdvp-common/src/styles/helpers/main-cq';

const Container = styled.div`
    display: ${(props) => !props.collapse ? 'block' : 'none'};
    ${mainCq.md`
        display: block;
    `}
`;

const Collapsible = ({
    collapse,
    children,
}) => {

    if(!children) {

        return null;

    }

    return (
        <Container
            collapse={collapse}
        >
            {children}
        </Container>
    );

};

Collapsible.propTypes = {
    collapse: PropTypes.bool,
    children: PropTypes.node,
};

Collapsible.defaultProps = {
    collapse: true,
};

export default Collapsible;
